import api from './index'

class AffiliateService {
	getAffiliateSetting() {
		return api.get('/affiliate/setting')
	}
	saveAffiliateSetting(data) {
		return api.post('/affiliate/setting', data)
	}
}

export default new AffiliateService()
